<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
       
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;"> Add Program </div>
      </ion-col>

      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!-- addprogram-form.component.html -->
    <form [formGroup]="addProgramForm" style="margin: 10px;">
      <ion-row>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Training Type <span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select"  formControlName="trainingType"
             >
             <mat-option [value]="type" *ngFor="let type of trainingTypes" class="custom-option">
              {{ type }}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="addProgramForm.get('trainingType')?.hasError('required') && addProgramForm.get('trainingType')?.touched">
              Training type is required
            </mat-error>
          </mat-form-field>
        </ion-col>



        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Programme Title <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="programTitle" placeholder="Enter title" />
            <mat-error *ngIf="addProgramForm.get('programTitle')?.hasError('required') && addProgramForm.get('programTitle')?.touched">
              Program title is required
            </mat-error>
          </mat-form-field>
        </ion-col>


        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Programme Code <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="programCode" placeholder="Enter code" />
            <mat-error *ngIf="addProgramForm.get('programCode')?.hasError('required') && addProgramForm.get('programCode')?.touched">
              Program code is required
            </mat-error>
          </mat-form-field>
        </ion-col>



        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">LMS Link<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="lmsLink" placeholder="Enter link" /> 
            <mat-error *ngIf="addProgramForm.get('lmsLink')?.hasError('required') && addProgramForm.get('lmsLink')?.touched">
              LMS Link is required
            </mat-error>
          </mat-form-field>
        </ion-col>


        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Start Date <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput  [matDatepicker]="picker1" formControlName="startDate" placeholder="select start Date"/>
            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="addProgramForm.get('startDate')?.hasError('required') && addProgramForm.get('startDate')?.touched">
              Start date is required
            </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">End Date <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput [matDatepicker]="picker2"  formControlName="endDate" placeholder="select End Date"/>
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <mat-error *ngIf="addProgramForm.get('endDate')?.hasError('required') && addProgramForm.get('endDate')?.touched">
            End date is required
          </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Functional/Behavioral <span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select behavior"  formControlName="functionalBehavioral"
             >
             <mat-option [value]="option" *ngFor="let option of functionalOptions" class="custom-option">
              {{ option }}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="addProgramForm.get('functionalBehavioral')?.hasError('required') && addProgramForm.get('functionalBehavioral')?.touched">
             Functional/Behavioral is required
            </mat-error>
          </mat-form-field>
        </ion-col>

  
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">No. of program days  <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="programDays" placeholder="Enter days" type="number"  />
            <mat-error *ngIf="addProgramForm.get('programDays')?.hasError('required') && addProgramForm.get('programDays')?.touched">
              No. of program days is required
              </mat-error>
          </mat-form-field>
        </ion-col>


        
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Budget cost <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <span matPrefix>Rs. </span>
            <input matInput formControlName="budgetCost" placeholder="Enter days" type="number"  />
            <mat-error *ngIf="addProgramForm.get('budgetCost')?.hasError('required') && addProgramForm.get('budgetCost')?.touched">
             Budget cost is required
             </mat-error>
          </mat-form-field>
        </ion-col>

             

        
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Actual cost <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <span matPrefix>Rs. </span>
            <input matInput formControlName="actualCost" placeholder="Enter days" type="number"  />
            <mat-error *ngIf="addProgramForm.get('actualCost')?.hasError('required') && addProgramForm.get('actualCost')?.touched">
              Budget cost is required
              </mat-error>
          </mat-form-field>
        </ion-col>
       
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Faculty Name <span class="red-cl">*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="facultyName" placeholder="Add faculty" readonly />
            <button matSuffix mat-button class="add-button" (click)="onClickAddNewFacultyPopup()">+ Add</button>
          </mat-form-field>
        </ion-col>
        

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Objective<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="objective" placeholder="Enter objective" />
            <mat-error *ngIf="addProgramForm.get('objective')?.hasError('required') && addProgramForm.get('objective')?.touched">
             Objective is required
              </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Select dept.<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select"  formControlName="department"
             >
             <mat-option [value]="dept" *ngFor="let dept of departments" class="custom-option">
              {{ dept }}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="addProgramForm.get('department')?.hasError('required') && addProgramForm.get('department')?.touched">
              Select dept. is required
              </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Select band.<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select"  formControlName="band"
             >
             <mat-option [value]="band" *ngFor="let band of bands" class="custom-option">
              {{ band }}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="addProgramForm.get('band')?.hasError('required') && addProgramForm.get('band')?.touched">
              Select band is required
              </mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Select grade.<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select"  formControlName="grade"
             >
             <mat-option [value]="grade" *ngFor="let grade of grades" class="custom-option">
              {{ grade }}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="addProgramForm.get('grade')?.hasError('required') && addProgramForm.get('grade')?.touched">
              Select grade is required
              </mat-error>
          </mat-form-field>
        </ion-col>


        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Location of programme <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="location" placeholder="Enter location"  />
            <mat-error *ngIf="addProgramForm.get('location')?.hasError('required') && addProgramForm.get('location')?.touched">
          Location is required
              </mat-error>
          </mat-form-field>
        </ion-col>

      </ion-row>

      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="closeDialog()">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10"
           [style.background-color]="buttonColorName" (click)="submitProgram()">
        submit
          </button>
        </ion-col>
      </ion-row>
    </form>

  </div>
</div>
